import { useContext } from "react"
import { AppSpan, AppText, Button, CustomContainer, FlexRow } from "src/style"
import { AppCenterPopupD2, CenterPopupHeaderD2 } from "src/component"
import UserContext from "src/provider/state-manager/userProvider"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import helpers from "src/utils/helpers"
import { moneyFormat } from "src/utils/utility"
import { MdEdit } from "react-icons/md";

export const ConfirmTransferD2: React.FC<any> = ({data, next, back, close}) => {
    const {user:{accountInfo}} = useContext(UserContext)
    const {info: {institutionData}} = useContext(AppInfoContext)

    const acctDetails = helpers.getAccountDetailsWithAcctNo(accountInfo, data?.senderAccount)

    return (
        <AppCenterPopupD2 height='65.8' zIndex='6' close={close} overflow='hidden'>
            <CenterPopupHeaderD2 title='Confirm Transfer' close={close} />
            <CustomContainer 
                height="65.8"
                style={{maxHeight: '85%'}}
                className="popup-content-container"
            >
                <CustomContainer topMargin="0.5">
                    <AppText align="center">Please confirm the transaction information below</AppText>
                    <CustomContainer
                        minHeight="19" topMargin="1.5" bgColor="#ffffff"
                        borderColor="#EAECF0" radius="0.8"
                    >
                        <FlexRow 
                            justifyContent="space-between" gap="1.5" minHeight="4"
                            bgColor="#E7F6F5" leftPadding="2" rightPadding="2"
                        >
                            <AppSpan color='#212121'textSize="1.6" >Sender</AppSpan>
                            <AppSpan color="#0D968F" textSize="2" cursor="pointer" topMargin="-0.5">
                                <MdEdit />
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer  padding="2" topPadding="0" topMargin="1.5">
                            <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                                <AppSpan color='#212121'>Name</AppSpan>
                                <AppText fontWeight="600" color="#212121">{acctDetails?.accountName}</AppText>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <AppSpan color='#212121'>Account</AppSpan>
                                <AppText fontWeight="600" color="#212121">{data?.senderAccount}</AppText>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <AppSpan color='#212121'>Transfer Type</AppSpan>
                                <AppText fontWeight="600" color="#212121">{data?.transferType != '2' ? 'Intra bank' : 'Inter bank'}</AppText>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <AppSpan color='#212121'>Amount</AppSpan>
                                <AppText fontWeight="600" color="#212121">{moneyFormat(String(data?.amount), true,institutionData?.defaultCurrency)}</AppText>
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>
                    <CustomContainer
                        minHeight="12.4"
                        topMargin="2" bgColor="#ffffff"
                        radius="0.8" borderColor="#EAECF0"
                    >
                        <FlexRow 
                            justifyContent="space-between" gap="1.5" minHeight="4"
                            bgColor="#E7F6F5" leftPadding="2" rightPadding="2"
                        >
                            <AppSpan color='#212121'textSize="1.6" >Receiver</AppSpan>
                            <AppSpan color="#0D968F" textSize="2" cursor="pointer" topMargin="-0.5">
                                <MdEdit />
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer  padding="2" topPadding="0" topMargin="1.5">
                            <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                                <AppSpan color='#212121'>Receiver</AppSpan>
                                <AppText fontWeight="600" color="#212121">{data?.beneficiaryName}</AppText>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <AppSpan color='#212121'>Account</AppSpan>
                                <AppText fontWeight="600" color="#212121">{data?.beneficiaryAccount}</AppText>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <AppSpan color='#212121'>Bank</AppSpan>
                                <AppText fontWeight="600" color="#212121">{data?.transferType === '0' ? institutionData?.name : data?.beneficiaryBank}</AppText>
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>
                    <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2.5">
                        <Button 
                            width='50' sizeUnit="%" height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            onClick={back}
                        >
                            Back
                        </Button>
                        <Button 
                            width='50' sizeUnit="%" height='4' 
                            borderColor='#0D968F' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={next}
                        >
                            Confirm
                        </Button>
                    </FlexRow>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopupD2>
    )
}